import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Markdown from 'literacy/assets/fonts/markdown';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function SimpleTable(props) {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Question</TableCell>
            <TableCell align="left">Choices</TableCell>
            <TableCell align="left">Hint</TableCell>
            <TableCell align="left">Real Answer</TableCell>
            <TableCell align="left">Learner Answer</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell align="left"><Markdown>{row.question}</Markdown></TableCell>
              <TableCell align="left">{JSON.stringify(row.choices)}</TableCell>
              <TableCell align="left">{row.hint}</TableCell>
              <TableCell align="left">{JSON.stringify(row.realAnswer)}</TableCell>
              <TableCell align="left">{JSON.stringify(row.studentAnswer)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
